var map = {
	"./10_nuts.png": 2514,
	"./1drink_12beer.png": 2515,
	"./1serving_8ounces.png": 2516,
	"./1serving_8ounces2.png": 2517,
	"./1serving_8ounces3.png": 2518,
	"./1serving_8ounces4.png": 2519,
	"./1serving_8ounces5.png": 2520,
	"./8ounces_1glass.png": 2521,
	"./can_1.png": 2522,
	"./can_2.png": 2523,
	"./can_3.png": 2524,
	"./cup.png": 2525,
	"./dried_serving_1/4cup.png": 2526,
	"./dried_serving_1:4cup.png": 2527,
	"./fresh_serving_1cup.png": 2528,
	"./glass_1.png": 2529,
	"./glass_2.png": 2530,
	"./golfball.png": 2531,
	"./halfthumb.png": 2532,
	"./hand_1.png": 2533,
	"./hand_2.png": 2534,
	"./hand_3.png": 2535,
	"./hand_4.png": 2536,
	"./hand_5.png": 2537,
	"./how.png": 898,
	"./serving_1/2cup.png": 2538,
	"./serving_1:2cup.png": 2539,
	"./serving_1tbsp.png": 2540,
	"./serving_3/4ounces.png": 2541,
	"./serving_3:4ounces.png": 2542,
	"./thumbx2.png": 2543,
	"./usda.png": 2544,
	"./vegetables_1cup.png": 2545,
	"./what.png": 896,
	"./wholethumb.png": 2546,
	"./why.png": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2513;